import {createSlice} from '@reduxjs/toolkit';


const initialState = {
    conditionalRoute: false,
    conditionalRouteFlow: '',
    
}


const routeRestrictionSlice = createSlice({
    name: 'routeRestrict',
    initialState,
    reducers:{
        setConditionalRoute:(state, action) =>{
            state.conditionalRoute = action.payload.isFlag;
            state.conditionalRouteFlow = action.payload.currentFlow;
        },

    }
})

export const { setConditionalRoute } = routeRestrictionSlice.actions
export default routeRestrictionSlice.reducer